import { render } from "./A2FView.vue?vue&type=template&id=7f6ca905&ts=true"
import script from "./A2FView.vue?vue&type=script&lang=ts"
export * from "./A2FView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__